import "../style/UeberUns.css";
import ueberUnsHead from "./images/Uberunshead.png";
import ueberUnsHead2 from "./images/Uberunshead2.png";
import ueberUnsHead3 from "./images/Uberunshead3.png";

function UeberUns() {
  return (
    <>
      <div className="medway-hero ueber-hero">
        <img
          src={ueberUnsHead}
          alt="Über uns Header"
          className="medway-hero__image"
        />
        <div
          className="medway-hero__content ueber-hero__content"
        >
          <div style={{ maxWidth: "520px" }}>
            <h1 className="medway-hero__title" style={{ fontWeight: 300 }}>
              Verbindung von zwei Nationen
            </h1>
            <p className="medway-hero__subtitle" style={{ fontWeight: 300 }}>
              Engagierte Pflegefachkräfte aus Tunesien für Krankenhäuser, Kliniken und Pflegeeinrichtungen
            </p>
          </div>
        </div>
      </div>
      <div
        className="ueber-section ueber-section--split"
      >
        <div style={{ flex: "1 1 420px", display: "flex", justifyContent: "flex-start" }}>
          <img
            src={ueberUnsHead2}
            alt="Gründung Illustration"
            style={{
              width: "100%",
              maxWidth: "640px",
              height: "auto",
              display: "block",
              objectFit: "cover",
            }}
          />
        </div>
        <div
          style={{
            flex: "1 1 360px",
            color: "#000",
            textAlign: "left",
            minWidth: "320px",
            lineHeight: 1.6,
          }}
        >
          <div style={{ display: "flex", alignItems: "flex-end", gap: "10px", marginBottom: "10px" }}>
            <span style={{ fontSize: "2.8rem", fontWeight: 700, color: "#a60b46" }}>01</span>
            <h2
              style={{
                margin: 0,
                fontSize: "2.2rem",
                fontWeight: 600,
                color: "#111D4B",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Gründung
            </h2>
          </div>
          <p style={{ marginTop: 0, marginBottom: "14px", fontSize: "1.05rem", fontWeight: 300, color: "#000" }}>
            Medway wurde von medizinischen Fachkräften aus Tunesien gegründet, die seit vielen Jahren in Deutschland
            leben und arbeiten. Aus eigener Erfahrung kennen die Gründer die Herausforderungen des deutschen
            Gesundheitssystems sowie den akuten Fachkräftemangel in Kliniken und Pflegeeinrichtungen.
          </p>
          <p style={{ margin: 0, fontSize: "1.05rem", fontWeight: 300, color: "#000" }}>
            Mit Medway verfolgen sie das Ziel, qualifizierte Pflegefachkräfte aus dem Ausland mit deutschen
            Gesundheitseinrichtungen zusammenzubringen. Dabei unterstützt Medway sowohl Fachkräfte als auch
            Arbeitgeber professionell, transparent und nachhaltig – für eine sichere Versorgung und langfristige
            Integration.
          </p>
        </div>
      </div>
      <div
        className="ueber-section"
      >
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <span style={{ fontSize: "2.8rem", fontWeight: 700, color: "#a60b46" }}>02</span>
          <h2
            style={{
              margin: "6px 0 0",
              fontSize: "2.2rem",
              fontWeight: 600,
              color: "#111D4B",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Der Full-Service-Partner
          </h2>
        </div>
        <div
          className="ueber-grid"
        >
          <div>
            <h3 style={{ margin: "0 0 12px", fontSize: "1.6rem", fontWeight: 700, color: "#111D4B" }}>
              Spezialisierte Agenturen
            </h3>
            <p style={{ margin: 0, fontSize: "1rem", fontWeight: 300 }}>
              Medway arbeitet mit mehreren spezialisierten Partneragenturen zusammen, die unterschiedliche fachliche Schwerpunkte und umfassende Expertise in den Gesundheitsbereich einbringen. Durch dieses starke Netzwerk können wir ein breites Leistungsspektrum anbieten und flexibel auf die individuellen Anforderungen unserer Kunden eingehen.

In enger Zusammenarbeit entwickeln wir maßgeschneiderte und nachhaltige Lösungen in der Personalberatung und -vermittlung im Gesundheitswesen.
            </p>
          </div>
          <div>
            <h3 style={{ margin: "0 0 12px", fontSize: "1.6rem", fontWeight: 700, color: "#111D4B" }}>
              Starkes Team
            </h3>
            <p style={{ margin: 0, fontSize: "1rem", fontWeight: 300 }}>
              Medway hat sich zu einem Full-Service-Partner für Personalberatung im Gesundheitswesen entwickelt. Mit einem engagierten Team 
              von rund 8 Mitarbeitenden unterstützt Medway seit der Gründung im Jahr 2024 seine Partner 
              erfolgreich bei der Besetzung verschiedener Positionen im Gesundheitssektor.
            </p>
          </div>
          <div>
            <h3 style={{ margin: "0 0 12px", fontSize: "1.6rem", fontWeight: 700, color: "#111D4B" }}>
              A bis Z
            </h3>
            <p style={{ margin: 0, fontSize: "1rem", fontWeight: 300 }}>
              Als Full-Service-Anbieter begleitet Medway den gesamten Rekrutierungsprozess von Anfang bis Ende. 
              Von der individuellen Beratung bis zur erfolgreichen Besetzung von Positionen im Gesundheitswesen bietet Medway umfassende und passgenaue Lösungen. 
              Dabei stehen eine persönliche Betreuung und die spezifischen Anforderungen der Partner stets im Mittelpunkt.
            </p>
          </div>
        </div>
      </div>
      <div className="ueber-image">
        <img
          src={ueberUnsHead3}
          alt="Full-Service Partner Illustration"
          style={{ width: "100%", height: "auto", display: "block", objectFit: "contain", margin: "0 auto" }}
        />
      </div>
    </>
  );
}

export default UeberUns;
